import { render } from "./Views.vue?vue&type=template&id=6f996a63"
import script from "./Views.vue?vue&type=script&lang=js"
export * from "./Views.vue?vue&type=script&lang=js"

import "./Views.vue?vue&type=style&index=0&id=6f996a63&lang=css"
script.render = render

export default script